// extracted by mini-css-extract-plugin
module.exports = {"stubLabel":"ServiceCoupons_stubLabel__SO2Yv","stubCode":"ServiceCoupons_stubCode__e2nIA","divider":"ServiceCoupons_divider__Ilt7k","price":"ServiceCoupons_price__pb3bc"};